// extracted by mini-css-extract-plugin
export default {"section-not-found":"EditSection_section-not-found__23NzS","page":"EditSection_page__ckFF7","sidebar-header-wrapper":"EditSection_sidebar-header-wrapper__WUN+S"};